import React, { useContext, useState } from "react";

import { GlobalContext } from "../../../app/providers/GlobalState";

import { FiltrosProvider } from "./FiltrosContext";

import Acessos from "../../../Geral/Acessos/Acessos";
import Header from "../../../User/Header";
import Filtros from "./componentes/Filtros";
import Tabelas from "./componentes/Tabelas";

const EnsinoEspecialPage = () => {
    const globalContext = useContext(GlobalContext);
    const nomeEscola = globalContext.estabelecimento?.nome;

    return (
        <FiltrosProvider>
            <Acessos funcionalidadeId={1} />
            <Header titulo={`Educação Especial - ${nomeEscola}`} />
            <div className="container container-body">
                <div className="bloco-cursos">
                    <div className="bloco-tabela">
                        <Filtros />
                        <Tabelas />
                    </div>
                </div>
            </div>
        </FiltrosProvider>
    );
};

export default EnsinoEspecialPage;
